<template>
  <div v-show="isPreloaderVisible" class="preloader-wrap">
    <SPreloader :size="size" />
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import SPreloader from '@/components/preloader/Preloader.vue'
import { usePreloaderFSM } from './usePreloaderFSM'

const props = defineProps({
  isActive: {
    type: Boolean,
    required: true,
  },
  size: {
    type: Number,
    default: 100,
  },
  delay: {
    type: Number,
    default: 500,
  },
  deactivationDelay: {
    type: Number,
    default: 1000,
  },
})

const { isPreloaderVisible } = usePreloaderFSM({
  signal: toRef(() => props.isActive),
  delay: props.delay,
  deactivationDelay: props.deactivationDelay,
}) 
</script>

<style scoped lang="scss">
.preloader-wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
